import { getIsAbnLoyaltyProgramEnabled } from '~/src/features/domru-bonus/constants/abnVariants';
import { TAppThunkDispatch, TGetState } from '~/src/store';

import { setBonusesValueValidity } from '../actionCreators';

const isAbnProgramTermsEnabled = getIsAbnLoyaltyProgramEnabled();

const validateBonusesValue = (isValid?: boolean) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const {
            loyalty: { info: { bonuses: availableBonuses } },
            payment: { paymentData: { paymentSum, bonusesValue } },
        } = getState();

        if (isValid !== undefined) {
            dispatch(setBonusesValueValidity(isValid));
        } else {
            const value = isAbnProgramTermsEnabled
                ? bonusesValue > 0 && bonusesValue <= Math.min(paymentSum / 0.2, availableBonuses)
                : bonusesValue > 0 && bonusesValue <= Math.min(paymentSum, availableBonuses);

            dispatch(setBonusesValueValidity(value));
        }
    };
};

export default validateBonusesValue;
